import { useQuery, UseQueryOptions, UseQueryResult } from '@tanstack/react-query';

import { queryForcedRankingStrategies, QUERY_KEY } from 'src/queries/queryForcedRankingStrategies';

type QueryKey = App.ForcedRankings.QueryKey;

export const useQueryForcedRankingStrategies = (
    accessToken: string | undefined | false,
    search: App.ForcedRankings.PagedSearch,
    options?: UseQueryOptions<string[], Error, string[], App.ForcedRankings.QueryKey>,
): UseQueryResult<string[], Error> => useQuery<string[], Error, string[], QueryKey>(
    [QUERY_KEY, accessToken, search],
    queryForcedRankingStrategies,
    options,
);
